<template>
  <teleport to="#site-header-container">
    <div
      class="
        site-header__brand-directory
        brand-directory__navigation-container
      "
      :class="{ [$class('active')]: active }"
      js-brand-directory="sticky"
    >
      <div class="container">
        <div class="brand-directory__navigation-items">
          <p
            class="
              brand-directory__navigation-title
              text-body-2xs
              text-body-xs-desktop
            "
            v-text="$string('general.page.brand_directory')"
          />

          <ul
            class="
              brand-directory__navigation
              brand-directory__navigation--site-header
            "
          >
            <li
              v-for="(letter) of letters"
              :key="letter.value"
              class="brand-directory__navigation-item"
            >
              <a
                class="
                  brand-directory__link
                  text-heading-2xs
                  text-heading-xs-desktop
                "
                :href="letter.url"
                type="button"
                v-text="letter.value"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>

/**
 * Vue: Brand directory (brand-directory)
 * -----------------------------------------------------------------------------
 * Brand directory.
 *
 * @param {Array} letters - Brand letters.
 *
 */
import { setIntersectionObserver } from '~/helpers/general'

export default {
  name: 'BrandDirectory',

  props: {
    letters: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      active: false,
      elements: {
        navigation: false,
        sticky: false,
      },
      selectors: {
        navigation: '[js-brand-directory="navigation"]',
        sticky: '[js-brand-directory="sticky"]',
      },
    }
  },

  mounted() {
    this.elements = {
      navigation: document.querySelector(this.selectors.navigation),
      sticky: document.querySelector(this.selectors.sticky),
    }

    if (this.elements.sticky) {
      document.documentElement.style.setProperty(
        '--brand-navigation-height',
        `${this.elements.sticky.offsetHeight}px`,
      )
    }

    if (!this.elements.navigation) {
      return
    }

    setIntersectionObserver({
      callback: this.handleIntersection,
      element: this.elements.navigation,
      threshold: [0, 1],
    })
  },

  methods: {

    /**
     * Handle navigation intersection.
     */
    handleIntersection() {
      const elementRectangle = this.elements.navigation.getBoundingClientRect()
      const elementTop = elementRectangle.top
      this.active = elementTop <= 0
    },
  },
}
</script>

<style lang="scss">
@import './brand-directory';
</style>
